import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.activeFilter = null
  }

  toggle(event) {
    const clickedButton = event.currentTarget
    const filterType = clickedButton.dataset.filterType

    if (this.activeFilter === filterType) {
      this.activeFilter = null
    } else {
      this.activeFilter = filterType
    }

    this.updateButtons()
    this.filterChatrooms()
  }

  updateButtons() {
    this.buttonTargets.forEach(button => {
      const type = button.dataset.filterType
      const outlineClass = this.outlineClassFor(type)
      const solidClass = this.solidClassFor(type)

      if (this.activeFilter === type) {
        button.classList.remove(outlineClass)
        button.classList.add(solidClass)
      } else {
        button.classList.remove(solidClass)
        button.classList.add(outlineClass)
      }
    })
  }

  filterChatrooms() {
    const chatrooms = document.querySelectorAll('.chatroom-wrapper')
    chatrooms.forEach(wrapper => {
      if (!this.activeFilter) {
        wrapper.style.display = ''
        return
      }

      let match = false
      switch (this.activeFilter) {
        case 'unread':
          match = wrapper.dataset.unread === 'true'
          break
        case 'pending':
          match = wrapper.dataset.pending === 'true'
          break
        case 'tray':
          match = wrapper.dataset.trayReminder === 'true'
          break
      }

      wrapper.style.display = match ? '' : 'none'
    })
  }

  outlineClassFor(type) {
    switch (type) {
      case 'unread': return 'btn-outline-success'
      case 'tray': return 'btn-outline-info'
      case 'pending': return 'btn-outline-warning'
      default: return 'btn-outline-secondary'
    }
  }

  solidClassFor(type) {
    switch (type) {
      case 'unread': return 'btn-success'
      case 'tray': return 'btn-info'
      case 'pending': return 'btn-warning'
      default: return 'btn-secondary'
    }
  }
}
